// import { Chart } from "react-google-charts";
import { Paper, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import FraudChart from "./FraudChart";
import FraudChartSpoty from "./FraudChartSpoty";
import FraudByTrack from "./FraudByTrack";
import FraudByTrack2 from "./FraudByTrack2";
import Donut from "./DonutChart";
import HelpFraudChartDialog from "./HelpFraudChartDialog";
import FraudLight from "./FraudLight";
import { useEffect, useState } from "react";

const useStyles = makeStyles((theme) => ({
  paper: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(5),
    borderRadius: theme.spacing(2),
    paddingBottom: theme.spacing(3),

    [theme.breakpoints.down("md")]: {
      borderRadius: theme.spacing(0),
      // padding: theme.spacing(3),
    },
  },
  section: {
    padding: theme.spacing(3),
  },
  topTitle: {
    marginTop: theme.spacing(5),
    fontWeight: "bold",
  },
  headerBox: {
    position: "relative",
    [theme.breakpoints.down("md")]: {
      borderRadius: theme.spacing(0),
      padding: theme.spacing(3),
    },
  },
  redBack: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    borderRadius: "inherit",
    backgroundColor: "#ffb7b7",
    opacity: 0.3,
    backgroundImage:
      "radial-gradient(circle at center center, #ff0202, #ffb7b7), repeating-radial-gradient(circle at center center, #ff0202, #ff0202, 34px, transparent 68px, transparent 34px)",
    backgroundBlendMode: "multiply",
    pointerEvents: "none", // Add this line to allow clicks to pass through
  }, // Add chart section styling similar to Ingresos section
  chartSection: {
    marginBottom: theme.spacing(12),
    "&:last-child": {
      marginBottom: 0,
    },
  },
}));

const FraudSection = ({ data, reporting }) => {
  const [percentage, setPercentage] = useState(0);
  const [color, setColor] = useState("green");

  const classes = useStyles();

  useEffect(() => {
    if (data) {
      const { streamsByPeriod, fraudLight } = data;

      // FRAUDULENT DATA
      const totalFraudulent = fraudLight.totalFraudulent;

      // LEGAL STREAMS DATA
      const totalStreamsCount = streamsByPeriod
        .filter((p) => fraudLight.periods.includes(p.period))
        .reduce((acc, curr) => acc + curr.cantidad, 0);

      const maxAllowedFraud = Math.round(totalStreamsCount * 0.01);

      const percentageNumber = parseFloat(
        (totalFraudulent / maxAllowedFraud) * 100
      );

      setPercentage(percentageNumber);

      if (percentageNumber > 30) {
        // setBackground(bg.yellow);
        setColor("yellow");
      }
      if (percentageNumber > 50) {
        // setBackground(bg.red);
        setColor("red");
      }
    }
  }, [data]);

  return (
    <>
      <Paper className={classes.paper}>
        <div
          className={classes.headerBox}
          style={{
            // background: "#ffdd33",
            borderRadius: "inherit",
            borderBottomRightRadius: 0,
            borderBottomLeftRadius: 0,
            // margin: "1rem",
          }}
        >
          <div className={classes.redBack}></div>
          <Typography
            variant="h4"
            align="center"
            gutterBottom
            className={classes.topTitle}
          >
            Actividad fraudulenta
          </Typography>

          <Typography variant="body1" align="center">
            Las plataformas han reportado actividad fraudulenta en tu contenido.
          </Typography>

          <FraudLight data={data} />
        </div>

        <div className={classes.chartSection} style={{ margin: "3em" }}>
          <FraudChartSpoty data={data} />
        </div>

        <div className={classes.chartSection} style={{ margin: "3em" }}>
          <FraudByTrack2 data={data} />
        </div>

        <div className={classes.chartSection}>
          <Donut
            data={data.donut}
            title="Reproducciones fraudulentas por track (detectadas por las plataformas)"
          />
        </div>
      </Paper>
    </>
  );
};

export default FraudSection;
